import { useQuery } from '@tanstack/react-query'
import { fetchActiveScandals, scandalKeys } from '@/services/scandals'

/**
 * Hook to fetch active scandals affecting a party.
 *
 * Returns scandals that can be addressed with damage control PR actions.
 *
 * @param partyId - The party ID to fetch scandals for
 * @param currentTick - Current game tick for filtering
 */
export function useActiveScandals(partyId: string | undefined, currentTick: number | undefined) {
  const scandalsQuery = useQuery({
    queryKey: scandalKeys.active(partyId!, currentTick!),
    queryFn: () => fetchActiveScandals(partyId!, currentTick!),
    enabled: !!partyId && currentTick !== undefined,
  })

  return {
    scandals: scandalsQuery.data ?? [],
    isLoading: scandalsQuery.isLoading,
    error: scandalsQuery.error,
    hasScandals: (scandalsQuery.data?.length ?? 0) > 0,
  }
}
